import React, { Component } from 'react';
import * as apiUserService from '../../services/apiUserService'
import Currency from './currency'
import { BASE_IMAGE_PATH } from '../../configs/api';
let userDataInterval
export default class UserDetailHeader extends Component {
   constructor(props) {
      super(props);
      this.state = {
         uid: "",
         userData: [],
         userMenuHide: true
      };
   }
   componentWillReceiveProps() {
      let user_data = localStorage.getItem("tokenData")
      user_data = JSON.parse(user_data)
      if(!(!!user_data && !!user_data.sub)){
         localStorage.clear();
         this.props.history.push("/auth") 
      }
      this.setState({ uid: user_data.sub })
   }
   componentDidMount() {
      let user_data = localStorage.getItem("tokenData")
      user_data = JSON.parse(user_data)
      if(!!user_data && !!user_data.sub){
         // this.submitForm(user_data.sub)
         let self = this
         this.setState({ uid: user_data.sub }, () => {
            userDataInterval = setInterval(function userDataLoad(){ 
               clearInterval(userDataInterval); 
               self.reloadeData(userDataLoad); 
            }, 3000)
         })
      } else {
         localStorage.clear();
         this.props.history.push("/auth") 
      }
   }
   componentWillUnmount(){
      clearInterval(userDataInterval);
   }
   reloadeData(callback) {
      let user_data = localStorage.getItem("tokenData")
      user_data = JSON.parse(user_data)
      if(!!user_data && !!user_data.sub){
         this.submitForm(user_data.sub, callback)
         this.setState({ uid: user_data.sub })
      }else{ 
         localStorage.clear();
         this.props.history.push("/auth") 
      }
   }
   async submitForm(user_id,callback) {
      const self = this;
      let userData = await apiUserService.getDashboard(user_id)
      self.setState({ userData: userData },()=>{
         if(!!callback){
            userDataInterval=setInterval(callback,3000)
         }
      })
      this.props.setUserAccData(userData)
      localStorage.setItem("userAccData", JSON.stringify(userData))
      this.props.setShowClubGames()
   }
   clean(obj) {
      for (var propName in obj) {
         if (obj[propName] === undefined) {
            delete obj[propName];
         }
      }
      return obj
   }
   render() {      
      return (
         <>
         <section className={this.props.isMktAnalysis ? "toggle-header master-balance-detail mt-0 market-p-fixed" : "toggle-header master-balance-detail mt-0"}>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className={this.state.userMenuHide?"text-center down-icon":"text-center up-icon"} onClick={()=>{this.setState({userMenuHide: !this.state.userMenuHide})}}>
                                <img  alt="" src={BASE_IMAGE_PATH + "/aimg/next.svg"}></img>
                            </div>
                        </div>
                    </div>
                </div>
                {!this.state.userMenuHide &&<div className="container-fluid">
               <ul className="row">
                  <li className="w-25">

                     <div className="mb-1 toolt">
                        <span className="tooltiptext">Your username.</span>
                        <label className="text-left mr-2">User ID <span className="uidpleft">:</span></label>
                        <span className="text-right">{!!this.state.userData && !!this.state.userData.username ? this.state.userData.username : ""}</span>
                     </div>
                     <div className="toolt">
                        <span className="tooltiptext">Your user role.</span>
                        <label className="text-left mr-2">User Type <span className="userpleft">:</span></label>
                        <span className="text-right">{!!this.state.userData && !!this.state.userData.role ? this.state.userData.role : ""}</span>
                     </div>
                  </li>

                  <li className="w-25 mw100">
                     <div className="mb-1 toolt">
                        <span className="tooltiptext">Aapko Upper Se Diya Gaya Balance.</span>
                        <span className="userheader-50 d-inline-block">
                           <label className="text-left mr-2">Given Bal <span className="givenpleft">:</span></label>
                           <span className="float-right">{!!this.state.userData && !!this.state.userData.balance ? <Currency key={"usr_bal"} className={this.state.userData.balance > 0 ? "text-green1" : this.state.userData.balance < 0 ? "text-red1" : ""} amount={this.state.userData.balance} showColor={false} /> : "0"}</span>
                        </span>
                        <span className="userheader-40 d-inline-block">&nbsp;</span>
                     </div>
                     <div className="toolt">
                        <span className="tooltiptext">Aapke Client Ko Dene Ke Baad Bacha Hua Balance.</span>
                        <span className="userheader-50 d-inline-block">
                           <label className="text-left mr-2">Available <span className="availablepleft">:</span></label>
                           <span className="float-right">{!!this.state.userData && !!this.state.userData.availableBalance ? <Currency key={"usr_availbal"} className={this.state.userData.availableBalance > 0 ? "text-green1" : this.state.userData.availableBalance < 0 ? "text-red1" : ""} amount={this.state.userData.availableBalance} showColor={false} /> : "0"}</span>
                        </span>
                        <span className="userheader-40 d-inline-block">&nbsp;</span>
                     </div>
                  </li>
                  <li className="w-25">
                     <div className="mb-1 toolt">
                        <span className="tooltiptext">Upper Level Ke Saath Hisab Ka Len-Den.</span>
                        <span className="userheader-50 d-inline-block">
                           <label className="text-left mr-2">Up Line {this.state.userData.upLineBalance > 0 ? "(lena)" : this.state.userData.upLineBalance < 0 ? "(dena)" : ""}<span className="uplinepleft">:</span></label>
                           <span className="float-right">{!!this.state.userData && !!this.state.userData.upLineBalance ? <Currency key={"usr_uplinebal"} className={this.state.userData.upLineBalance > 0 ? "text-green1" : this.state.userData.upLineBalance < 0 ? "text-red1" : ""} amount={this.state.userData.upLineBalance} showColor={false} /> : "0"}</span>
                        </span>
                        <span className="userheader-40 d-inline-block">&nbsp;</span>
                     </div>
                     <div className="toolt">
                        <span className="tooltiptext">Down Level Ke Saath Hisab Ka Len-Den.</span>
                        <span className="userheader-50 d-inline-block">
                           <label className="text-left mr-2">Down Line {this.state.userData.downLineBalance > 0 ? "(lena)" : this.state.userData.downLineBalance < 0 ? "(dena)" : ""}<span className="downlinepleft">:</span></label>
                           <span className="float-right">{!!this.state.userData && !!this.state.userData.downLineBalance ? <Currency key={"usr_downlinebal"} className={this.state.userData.downLineBalance > 0 ? "text-green1" : this.state.userData.downLineBalance < 0 ? "text-red1" : ""} amount={this.state.userData.downLineBalance} showColor={false} /> : "0"}</span>
                        </span>
                        <span className="userheader-40 d-inline-block">&nbsp;</span>
                     </div>
                  </li>
                  <li className="w-25 d-all">
                     <div className="mb-1 toolt">
                        <span className="tooltiptext">Upline + Downline Ka Bina Settle Kiya Hua Profit &amp; Loss Account.</span>
                        <span className="userheader-50 d-inline-block">
                           <label className="text-left mr-2">Current P&amp;L <span className="currentpleft">:</span></label>
                           <span className="float-right">{!!this.state.userData && (!!this.state.userData.upLineBalance || !!this.state.userData.downLineBalance) ? <Currency key={"usr_currpnl"} className={(this.state.userData.upLineBalance + this.state.userData.downLineBalance) > 0 ? "text-green1" : (this.state.userData.upLineBalance + this.state.userData.downLineBalance) < 0 ? "text-red1" : ""} amount={(this.state.userData.upLineBalance + this.state.userData.downLineBalance)} showColor={false} /> : "0"}</span>
                        </span>
                        <span className="userheader-40 d-inline-block">&nbsp;</span>
                     </div>
                     <div className="toolt">
                        <span className="tooltiptext">Your current market exposure with all kind of games that your clients are playing currently.</span>
                        <span className="userheader-50 d-inline-block">
                           <label className="text-left mr-2">Exposure <span className="exposurepleft">:</span></label>
                           <span className="float-right">{!!this.state.userData && !!this.state.userData.exposure ? <Currency key={"usr_expo"} className={this.state.userData.exposure > 0 ? "text-green1" : this.state.userData.exposure < 0 ? "text-red1" : ""} amount={this.state.userData.exposure} showColor={false} /> : "0"}</span>
                        </span>
                        <span className="userheader-40 d-inline-block">&nbsp;</span>
                     </div>
                  </li>
                  <li className="w-25 d-all">
                     <div className="toolt">
                        <span className="tooltiptext">Mera Profit &amp; Loss Account.</span>
                        <span className="userheader-50 d-inline-block">
                           <label className="text-left mr-2">My P&amp;L <span className="mypnlpleft">:</span></label>
                           <span className="float-right">{!!this.state.userData && !!this.state.userData.pnl ? <Currency key={"usr_pnl"} className={this.state.userData.pnl > 0 ? "text-green1" : this.state.userData.pnl < 0 ? "text-red1" : ""} amount={this.state.userData.pnl} showColor={false} /> : "0"}</span>
                        </span>
                        <span className="userheader-40 d-inline-block">&nbsp;</span>
                     </div>
                  </li>
                  {/* ONLY SHOW WIDTH 991 to 768 START */}
                  <li className="w-25 tablet-100 d-tablet">
                     <div className="mb-1 tablet-50 toolt">
                        <span className="tooltiptext"> Upline + Downline Ka Bina Settle Kiya Hua Profit &amp; Loss Account.</span>
                        <span className="userheader-50 d-inline-block">
                           <label className="text-left mr-2">Current P&amp;L <span className="currentpleft">:</span></label>
                           <span className="float-right">{!!this.state.userData && (!!this.state.userData.upLineBalance || !!this.state.userData.downLineBalance) ? <Currency key={"usr_currpnl"} className={(this.state.userData.upLineBalance + this.state.userData.downLineBalance) > 0 ? "text-green1" : (this.state.userData.upLineBalance + this.state.userData.downLineBalance) < 0 ? "text-red1" : ""} amount={(this.state.userData.upLineBalance + this.state.userData.downLineBalance)} showColor={false} /> : "0"}</span>
                        </span>
                        <span className="userheader-40 d-inline-block">&nbsp;</span>
                     </div>
                     <div className="tablet-50 toolt">
                        <span className="tooltiptext">Your current market exposure with all kind of games that your clients are playing currently.</span>
                        <span className="userheader-50 d-inline-block">
                           <label className="text-left mr-2">Exposure <span className="exposurepleft">:</span></label>
                           <span className="float-right">{!!this.state.userData && !!this.state.userData.exposure ? <Currency key={"usr_expo"} className={this.state.userData.exposure > 0 ? "text-green1" : this.state.userData.exposure < 0 ? "text-red1" : ""} amount={this.state.userData.exposure} showColor={false} /> : "0"}</span>
                        </span>
                        <span className="userheader-40 d-inline-block">&nbsp;</span>
                     </div>
                     <div className="mb-1 tablet-50 toolt">
                        <span className="tooltiptext"> Mera Profit &amp; Loss Account.</span>
                        <span className="userheader-50 d-inline-block">
                           <label className="text-left mr-2">My P&amp;L <span className="mypnlpleft">:</span></label>
                           <span className="float-right">{!!this.state.userData && !!this.state.userData.pnl ? <Currency key={"usr_pnl"} className={this.state.userData.pnl > 0 ? "text-green1" : this.state.userData.pnl < 0 ? "text-red1" : ""} amount={this.state.userData.pnl} showColor={false} /> : "0"}</span>
                        </span>
                        <span className="userheader-40 d-inline-block">&nbsp;</span>
                     </div>
                  </li>
                  {/* ONLY SHOW  WIDTH 991 to 768 END */}
               </ul>
            </div> }
            </section>
         </>
      )
   }
}
